var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"col-lg-8 col-xl-6 col-12 offset-lg-2"},[_c('h1',[_vm._v("Werbestatistiken")]),_c('advStatistics')],1)}
var staticRenderFns = []

export { render, staticRenderFns }